module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-sparen-circle-7ecdb6d7f6318857c35c9c5d96d29539.svg";